/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { getEventId, getEventName } from '@e180/domain/lib/event/util';

import RetrieveUsernameSuccessDumb from './RetrieveUsernameSuccessDumb';
import { sendLoginLinkWithMembershipId } from 'src/shared/app/authentication/action/support/supportLoginLinkActions';
import {
  getRetrievedUsername,
  getRetrievedMembership,
} from 'src/shared/app/authentication/selector/support/appRetrieveUsernameSelector';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

type Props = {
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (state: Object, { intl }: Props): Object => {
  // $FlowIssue
  const event: BraindateEvent = getEventPublicData(state);

  return {
    username: getRetrievedUsername(state),
    eventName: getEventName(event, intl.locale),
    // Merge
    membership: getRetrievedMembership(state),
    event,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleSendLoginLink() {
    const { membership, event } = stateProps;
    const eventId = getEventId(event);

    return dispatch(sendLoginLinkWithMembershipId(membership, eventId));
  },
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(RetrieveUsernameSuccessDumb);
